export const phoneToE164 = (phone: string) => phone.replace(/[^0-9+]/g, '');

export const DIAL_CODE_DATA_ATTR = 'data-dial-code';

export enum InternationalCountryData {
	name = 'International',
	iso2 = 'un',
	dialCode = '',
}
